import React from 'react';

// EP rewards are now shown inline on completion screens via EpBadge.
// This overlay component is kept as a no-op for backward compatibility.
export const EpRewardOverlay = () => {
  return null;
};
